module.exports = __webpack_public_path__ + "static/scale-model-of-guaranty-building-in-buffalo-new-york-6332adcda335e9dce93947fad7875c58.png";